module.exports = __webpack_public_path__ + "img/bg.c8332b30.png";